import _ from "lodash";
import errorDecorator from "@/components/fields/errors";
import PracticesService from "@/services/PracticesService";

export default {
  mixins: [errorDecorator],

  data() {
    let locationOptions = [""];
    PracticesService.get(this.id).then(practice => {
      _.forEach(practice.attributes.locations, loc => {
        locationOptions.push({ value: loc.location, label: loc.location });
      });
    });

    let fields = [
      {
        key: "firstName",
        type: "input",
        templateOptions: {
          label: "First Name"
        },
        required: true
      },
      {
        key: "lastName",
        type: "input",
        templateOptions: {
          label: "Last Name"
        },
        required: true
      },
      {
        key: "title",
        type: "input",
        templateOptions: {
          label: "Title"
        },
        required: true
      },
      {
        key: "email",
        type: "input",
        templateOptions: {
          label: "Email",
          inputType: "email"
        },
        required: true
      }
    ];

    if (this.$props.userId) {
      fields.push({
        key: "location",
        type: "select",
        options: locationOptions,
        templateOptions: {
          label: "Location"
        },
        required: false
      });
    }

    fields = fields.concat([
      {
        key: "phoneNumber",
        type: "input",
        templateOptions: {
          label: "Phone Number",
          inputType: "tel"
        },
        required: true
      },
      {
        key: "roleId",
        type: "select",
        options: [
          { value: "Practice Staff", label: "Practice Staff" },
          { value: "Practice Admin", label: "Practice Admin" },
          { value: "Practice Provider", label: "Practice Provider" }
        ],
        templateOptions: {
          label: "Role"
        },
        required: true
      },
      {
        key: "password",
        type: "password",
        templateOptions: {
          label: "Password",
          score: 0
        },
        required: true
      },
      {
        key: "notifyEmail",
        type: "checkbox",
        templateOptions: {
          label: "Interview Notify Email"
        },
        required: true
      },
      {
        key: "notifyText",
        type: "checkbox",
        templateOptions: {
          label: "Interview Notify SMS"
        },
        required: true
      }
    ]);

    return {
      form: {},
      fields: fields
    };
  },

  mounted() {
    const isHealeo = this.$store.getters["practice/isHealeo"](this.$props.id);
    if (isHealeo) {
      const index = _.findIndex(this.fields, ["key", "roleId"]);
      this.fields[index].options = [
        { value: "Virtriage Staff", label: "Virtriage Staff" },
        { value: "Super Admin", label: "Super Admin" }
      ];
    }
  }
};
